import { Coordinate } from 'ol/coordinate';
import { Map } from 'ol';
import { Projection, transform } from 'ol/proj';

import { Extent } from 'ol/extent';

interface LatLng {
  lat: number;
  lng: number;
}

interface Size {
  width: number;
  height: number;
}

interface MapDimensions {
  center: LatLng;
  zoomLevel: number;
  size: Size;
  extent: Extent;
  southWest: LatLng;
  northEast: LatLng;
}

export function getDimensionsFromMap(
  map: Map,
  displayProjection: Projection | string,
  dataProjection: Projection | string
): MapDimensions | null {
  const viewObject = map.getView();
  const viewCenter = viewObject.getCenter();
  const mapSize = map.getSize();
  if (viewCenter == null || mapSize == null) {
    return null;
  }
  const center = transform(viewCenter, displayProjection, dataProjection);
  const extent = viewObject.calculateExtent(mapSize);
  const northEast = transform(
    [extent[2], extent[3]],
    displayProjection,
    dataProjection
  );
  const southWest = transform(
    [extent[0], extent[1]],
    displayProjection,
    dataProjection
  );

  return {
    center: mapCoordinateToLatLng(center),
    size: { width: mapSize[0], height: mapSize[1] },
    zoomLevel: viewObject.getZoom() ?? 0,
    extent,
    northEast: mapCoordinateToLatLng(northEast),
    southWest: mapCoordinateToLatLng(southWest),
  };
}

const mapCoordinateToLatLng = (coordinate: Coordinate): LatLng => ({
  // CLASSIC-9402 we have issues with the backend, when we only send an integer like 0
  lat: parseFloat(coordinate[1].toFixed(6)),
  lng: parseFloat(coordinate[0].toFixed(6)),
});
